import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import { getInsightPredictions } from '@terminal/services/insights/insights-service';

const QUERY_KEY_INSIGHT_PREDICTIONS = 'QUERY_KEY_INSIGHT_PREDICTIONS';

export const useGetInsightPredictions = (insightId: string) =>
  useQuery({
    queryKey: [QUERY_KEY_INSIGHT_PREDICTIONS, insightId],
    queryFn: () => getInsightPredictions(insightId),
    enabled: !!insightId,
    staleTime: getTimeTillEndOfDayMs(),
  });
